import { z } from 'zod';
import { ActorSchema } from '../common/actor.schema';

// Published when an active admin adds a new admin via the admin app.
// Doubles as the trigger for the admin-invite deliverable: the
// communications module subscribes and dispatches the signup-or-signin
// email based on whether WorkOS already knows the recipient.
export const AdminAddedPayloadSchema = z.object({
  adminId: z.uuid(),
  email: z.email(),
  fullName: z.string().min(1),
  actor: ActorSchema,
  occurredAt: z.iso.datetime(),
});

export type AdminAddedPayload = z.infer<typeof AdminAddedPayloadSchema>;

// Published when an active admin deactivates another admin (or themselves
// — guarded against in the application layer). Audit-only; the
// deactivated row stops resolving from `getAdminByEmail` immediately.
export const AdminDeactivatedPayloadSchema = z.object({
  adminId: z.uuid(),
  email: z.email(),
  actor: ActorSchema,
  occurredAt: z.iso.datetime(),
});

export type AdminDeactivatedPayload = z.infer<typeof AdminDeactivatedPayloadSchema>;
